export default __webpack_public_path__ + "static/core-collection-desktop-ff6bd161e52a9a23ec86c25179829d37.webp";